import { useTranslation } from "react-i18next";
import { Button } from "../../../../../../shared/components/button/Button";

const ActionsPerformanceDataExplorerFields = ({
  label,
  fields,
  onUpdateFieldFilter,
}) => {
  const { t } = useTranslation();

  return (
    <div className="w-1/2 flex flex-col min-h-[14vh] max-h-[14vh]">
      <div className="text-base font-semibold mb-2">{label}</div>
      <div className="flex flex-row flex-wrap gap-x-2 gap-y-1">
        {fields.map((field) => (
          <Button
            key={`${field.label}_${field.value}`}
            variant="outline"
            size="sm"
            className={field.toggle ? "text-adq-blue bg-adq-azure/50" : ""}
            onClick={() => onUpdateFieldFilter(field)}
          >
            {t(field.label)}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default ActionsPerformanceDataExplorerFields;
